import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/img/icons/cart.svg'


const _hoisted_1 = { class: "container pb-100" }
const _hoisted_2 = { class: "shop-card-wrap style-one gx-0" }
const _hoisted_3 = { class: "shop-promo style-one lh-1 position-absolute text-white" }
const _hoisted_4 = { class: "shop-img overflow-hidden" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "shop-info d-flex align-items-center justify-content-between" }
const _hoisted_7 = { class: "fs-20" }
const _hoisted_8 = { class: "fs-20 fw-bold f-secondary text_primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "section-title mb-30" }, "Related Products", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "shop-card position-relative",
          key: product.id
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(product.state), 1),
          _createVNode(_component_router_link, {
            class: "add-to-cart position-absolute",
            to: "/cart"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Image"
              }, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: product.image,
              alt: "Image",
              class: "d-block mx-auto transition"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _cache[1] || (_cache[1] = _createStaticVNode("<ul class=\"ratings list-style\"><li><i class=\"ri-star-s-fill\"></i></li><li><i class=\"ri-star-s-fill\"></i></li><li><i class=\"ri-star-s-fill\"></i></li><li><i class=\"ri-star-s-fill\"></i></li><li><i class=\"ri-star-s-fill\"></i></li></ul>", 1)),
              _createElementVNode("h3", _hoisted_7, [
                _createVNode(_component_router_link, { to: "/product-details" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(product.title), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(_component_router_link, {
                to: "/shop-left-sidebar",
                class: "shop-cat"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(product.category), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("span", _hoisted_8, " $" + _toDisplayString(product.price), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}